import React from 'react';
import PendingOrdersList from '../OrdersList/variants/PendingOrdersList';
import InProgressOrdersList from '../OrdersList/variants/InProgressOrdersList';
import CompletedOrdersList from '../OrdersList/variants/CompletedOrdersList';
import DeclinedOrdersList from '../OrdersList/variants/DeclinedOrdersList';

import s from './OrdersMobilePageContent.scss';

const OrdersMobilePageContent: React.FC = () => {
  return (
    <div className={s['root']}>
      <PendingOrdersList />
      <InProgressOrdersList />
      <CompletedOrdersList />
      <DeclinedOrdersList />
    </div>
  );
};
OrdersMobilePageContent.displayName = 'OrdersMobilePageContent';

export default OrdersMobilePageContent;
